import React from 'react';

import { ClientReportingMicroFrontend } from './ClientReportingPayoutsMFE';

export const ReportDashboard = () => (
  <ClientReportingMicroFrontend
    portalSection="reports"
    dataFd="client-reporting-dashboards-micro-frontend"
  />
);

export default ReportDashboard;
